import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { LocalizedLink as Link } from "@/components/LocalizedLink";

// Phone-only booking bar: appears once the guest has scrolled past the top
// of the page and steps aside when the page's own booking band is on screen.
const StickyBook = ({ to, label, priceText, watchTestId }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let past = false;
    let bandVisible = false;
    const update = () => setShow(past && !bandVisible);
    const onScroll = () => {
      past = window.scrollY > 520;
      update();
    };
    const band = document.querySelector(`[data-testid="${watchTestId}"]`);
    const io = band
      ? new IntersectionObserver(([entry]) => {
          bandVisible = entry.isIntersecting;
          update();
        })
      : null;
    io?.observe(band);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => {
      io?.disconnect();
      window.removeEventListener("scroll", onScroll);
    };
  }, [watchTestId]);

  return (
    <div
      inert={!show}
      data-testid="unit-sticky-book"
      className={`md:hidden fixed inset-x-0 bottom-0 z-40 border-t border-linen/70 bg-cream/95 backdrop-blur-xl px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] flex items-center justify-between gap-4 slide-bar ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
    >
      {priceText && <span className="font-display text-xl text-ink tabular">{priceText}</span>}
      <Link
        to={to}
        className={`group inline-flex items-center justify-center gap-2 rounded-full bg-terracotta px-6 py-3 text-sm font-medium text-cream hover:bg-terracotta-dark btn-press ${priceText ? "" : "flex-1"}`}
      >
        {label}
        <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
};

export default StickyBook;
